import { type FunctionComponent } from "react";

import { BTAlert } from "commonComponents/btWrappers/BTAlert/BTAlert";
import { BTLink } from "commonComponents/btWrappers/BTLink/BTLink";

interface ITextVerificationBannerProps {
    handlePreferencesClicked: () => void;
}

export const TextVerificationBanner: FunctionComponent<ITextVerificationBannerProps> = ({
    handlePreferencesClicked,
}) => {
    return (
        <BTAlert
            type="info"
            title="Verification text message sent."
            message={
                <>
                    To update your notification settings, visit&nbsp;
                    <BTLink to="#" linkType="link" onClick={handlePreferencesClicked}>
                        preferences.
                    </BTLink>
                </>
            }
            data-testid="verificationTextAlert"
            showIcon
            closable
        />
    );
};
